"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHomeState = void 0;
var HomeTranslate_init_1 = require("@/pages/home/states/HomeTranslate.init");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var HomeArticle_init_1 = require("@/pages/home/states/HomeArticle.init");
var HomeTestimonial_init_1 = require("@/pages/home/states/HomeTestimonial.init");
var HfilterOption_init_1 = require("@/pages/search/states/HfilterOption.init");
var MortgageRateTableInputs_init_1 = require("@/pages/mortagage/states/MortgageRateTableInputs.init");
var HomeFeature_init_1 = require("@/pages/home/states/HomeFeature.init");
var MortgageLimitTable_init_1 = require("@okay/okay-mortgage/src/states/MortgageLimitTable.init");
var MortgageInsuranceTable_init_1 = require("@okay/okay-mortgage/src/states/MortgageInsuranceTable.init");
exports.defaultHomeState = {
    t: HomeTranslate_init_1.defaultHomeTranslate,
    properties: ResultPageState_init_1.defaultResultItemsWithAgent,
    articles: HomeArticle_init_1.defaultHomeArticles,
    uniqueListingCount: 6778,
    weeklyNewListingCount: 613,
    testimonials: HomeTestimonial_init_1.defaultHomeTestimonials,
    features: HomeFeature_init_1.defaultHomeFeatures,
    featureSliderIndex: 0,
    currentTestimonialIndex: 2,
    calcDownpayValue: 2800000,
    calcDownpayMin: 400000,
    calcDownpayMax: 100000000,
    calcDownpayStep: 100000,
    calcMonthlyValue: 71000,
    calcMonthlyMin: 20000,
    calcMonthlyMax: 300000,
    calcMonthlyStep: 10,
    calcTenorValue: 30,
    calcTenorMin: 1,
    calcTenorMax: 30,
    calcTenorStep: 1,
    calcRateValue: 3.5,
    calcRateValueIncreasePercent: 3,
    calcRateMin: 1.0,
    calcRateMax: 5.0,
    calcRateStep: 0.01,
    forbesHtml: "<p><span class=\"c-homeforbes__text--strong\"\n  >OKAY.com is proud to be a Founding Member of Forbes Global Properties</span>, an elite invitation-only consortium of the top real estate agencies worldwide, connecting buyers and sellers to the highest caliber of property experts and luxury properties around the globe.</p><p>The network is the exclusive worldwide partner of Forbes, one of the world\u2019s most trusted media brands, with featured properties introduced to potential buyers across digital, social media, print and editorial content.</p><p>Members are highly vetted for their integrity, knowledge and trust, and are considered to be leading experts within their market. With numerous awards for its technology innovation and service, OKAY.com is the exclusive member in Hong Kong, bringing a new level of representation to homeseekers while enabling property owners to achieve better exposure to prospective tenants and buyers than any other agency in Hong Kong.</p>",
    fgpUrl: 'https://www.forbesglobalproperties.com/',
    salePricePresetsHk: HfilterOption_init_1.defaultBuyPricePreset,
    calcMortgagePlans: MortgageInsuranceTable_init_1.defaultMortgageInsuranceTableCounterCycle,
    calcMortgageLimits: MortgageLimitTable_init_1.defaultMortgageLimitTable,
    calcLegalAmount: 10000,
    calcRateTableInputs: MortgageRateTableInputs_init_1.defaultMortgageRateTableInput,
    searchSuggestionActive: false,
    searchLoading: false,
    searchSuggestionGroups: [],
    searchSuggestionGroupIndex: -1,
    searchSuggestionRowIndex: -1,
    searchInputText: '',
    fullscreenLoading: false,
    isTestimonialAutoPlay: false,
};
